import { Heading, Text } from "@/design-system";
import type { LegalSection } from "../content/types";
import { LegalBlockView } from "./legalBlockView";
import { LegalRichText } from "./legalRichText";

type LegalSectionViewProps = {
  section: LegalSection;
  /** Posição na página, a partir de 1 — vira o "01", "02" do título. */
  number: number;
};

/**
 * Uma seção do documento: número de cláusula, título, o resumo "Em poucas
 * palavras" e o texto completo. O resumo vem antes de propósito — quem só
 * quer a resposta para ali; quem precisa do detalhe segue lendo.
 */
export const LegalSectionView = ({
  section,
  number,
}: LegalSectionViewProps) => {
  const titleId = `${section.id}-title`;

  return (
    <section
      id={section.id}
      aria-labelledby={titleId}
      className="border-ds-border flex scroll-mt-28 flex-col gap-5 border-t pt-10 first:border-t-0 first:pt-0"
    >
      <div className="flex flex-col gap-2">
        <span
          aria-hidden="true"
          className="font-ds-display text-ds-h4 text-ds-brand-700"
        >
          {String(number).padStart(2, "0")}
        </span>
        <Heading level={2} id={titleId}>
          {section.title}
        </Heading>
      </div>

      <div className="border-ds-brand-500 bg-ds-brand-50 rounded-ds-md flex flex-col gap-1 border-l-4 px-4 py-3">
        <Text as="p" size="caption" tone="brand" weight="semibold">
          Em poucas palavras
        </Text>
        <Text>
          <LegalRichText text={section.summary} />
        </Text>
      </div>

      {section.blocks.map((block, index) => (
        <LegalBlockView key={index} block={block} />
      ))}
    </section>
  );
};
